import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "minutesToDuration",
})
export class MinutesToDurationPipe implements PipeTransform {


    transform(input: string, exceptionValue, exceptionString) {
        if (exceptionValue && exceptionValue === input) {
            if (!exceptionString) {
                console.warn("minutesToDuration expects an 'exceptionString' when using 'exceptionValue'");
            }

            return exceptionString;
        }

        let inputAsNumber = Math.round(+input) || 0;
        let displayMinutes: number;
        let displayHours: number;

        if (inputAsNumber >= 0) {
            displayMinutes = Math.floor(inputAsNumber % 60);
            displayHours = Math.floor(inputAsNumber / 60);
        }
        else {
            displayMinutes = Math.ceil(inputAsNumber % 60);
            displayHours = Math.ceil(inputAsNumber / 60);
        }

        let hourDisplay = "h";
        let minDisplay = "m";

        return displayHours !== 0
            ? `${displayHours}${hourDisplay}, ${displayMinutes}${minDisplay}`
            : `${displayMinutes}${minDisplay}`;
    }
}
